import React, { useState } from 'react';
import { FaHome, FaChevronRight, FaUser, FaEnvelope, FaPhone, FaBriefcase, FaMapMarker, FaTransgender, FaCalendar, FaMapPin, FaGraduationCap, FaFileUpload, FaPaperPlane, FaUsers, FaChartLine, FaLaptop, FaGift } from 'react-icons/fa';
import { useLanguage } from '../../contexts/LanguageContext';
import { database, storage, ref, set, push, storageRef, uploadBytes, getDownloadURL } from '../../firebase';

const Career = () => {
  const { language } = useLanguage();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',

    gender: '',
    dateOfBirth: '',
    address: '',

    yearOfPassing: '',
    resume: null
  });

  // Translations
  const translations = {
    en: {
      pageTitle: 'Career Opportunities',
      pageSubtitle: 'Join Our Growing Team',
      heroBannerText: 'Building Careers, Brightening Futures, Samata is Your Companion!',
      breadcrumbHome: 'Home',
      breadcrumbCareer: 'Career',
      applicationForm: 'Application Form',
      fillApplication: 'Please fill out the application form below',
      personalInfo: 'Personal Information',
      name: 'Name',
      email: 'Email',
      phoneNo: 'Phone No.',
      jobPosition: 'Job Position',
      selectJobPosition: 'Select Job Position',
      jobLocation: 'Job Location',
      branch: 'Branch',
      goldLoanCounter: 'Gold Loan Counter',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      others: 'Others',
      dateOfBirth: 'Date of birth',
      address: 'Address',
      pincode: 'Pincode',
      educationInfo: 'Education Information',
      yearOfPassing: 'Year of passing',
      selectYearOfPassing: 'Select Year of passing',
      uploadResume: 'Upload Resume',
      chooseFile: 'Choose File',
      noFileChosen: 'No file chosen',
      submit: 'SUBMIT',
      uploadCvResume: 'Upload your CV/Resume',
      requiredField: 'This field is required',
      invalidEmail: 'Invalid email address',
      invalidPhone: 'Invalid phone number',
      formSubmitted: 'Application submitted successfully!',
      submitting: 'Submitting your application...',
      errorSubmitting: 'Error submitting application. Please try again.',
      whyJoinTitle: 'Come Join Us, Grow Together!',
      whyJoinDescription: 'Join our team and be part of a growing organization that values your contribution and supports your professional development.',
      whatWeDoTitle: 'What Will You Do With Us?',
      features: [
        {
          title: 'Inclusive Work Culture',
          description: 'Work in a supportive environment where diversity is celebrated and every voice matters.'
        },
        {
          title: 'Career Growth',
          description: 'Access continuous learning opportunities and clear career advancement paths.'
        },
        {
          title: 'Modern Workplace',
          description: 'Experience cutting-edge technology and modern facilities that enhance productivity.'
        },
        {
          title: 'Rewards & Benefits',
          description: 'Enjoy competitive compensation, comprehensive benefits, and recognition for your achievements.'
        }
      ],
      workCultureTitle: 'The Working System of Our Society/ Work Approach',
      workCultureDescription: 'We foster a collaborative environment where innovation thrives and every team member contributes to our collective success.'
    },
    mr: {
      pageTitle: 'करिअर संधी',
      pageSubtitle: '',
      heroBannerText: 'करियर घडवण्यासाठी, भविष्य उज्ज्वल करण्यासाठी, आम्ही तुमच्या सोबत आहोत!',
      breadcrumbHome: 'होम',
      breadcrumbCareer: 'करिअर',
      applicationForm: 'अर्ज पत्र',
      fillApplication: 'कृपया खालील अर्ज पत्र भरा',
      personalInfo: 'वैयक्तिक माहिती',
      name: 'नाव',
      email: 'ईमेल',
      phoneNo: 'फोन नंबर',
      jobPosition: 'नोकरी पद',
      selectJobPosition: 'नोकरी पद निवडा',
      jobLocation: 'नोकरी ठिकाण',
      branch: 'शाखा',
      goldLoanCounter: 'गोल्ड लोन काउंटर',
      gender: 'लिंग',
      male: 'पुरुष',
      female: 'स्त्री',
      others: 'इतर',
      dateOfBirth: 'जन्मतारीख',
      address: 'पत्ता',
      pincode: 'पिन कोड',
      educationInfo: 'शैक्षणिक माहिती',
      yearOfPassing: 'उत्तीर्ण वर्ष',
      selectYearOfPassing: 'उत्तीर्ण वर्ष निवडा',
      uploadResume: 'रेझ्युमे अपलोड करा',
      chooseFile: 'फाइल निवडा',
      noFileChosen: 'कोणतीही फाइल निवडलेली नाही',
      submit: 'सबमिट करा',
      uploadCvResume: 'आपले CV/रेझ्युमे अपलोड करा',
      requiredField: 'हे फील्ड आवश्यक आहे',
      invalidEmail: 'अवैध ईमेल पत्ता',
      invalidPhone: 'अवैध फोन नंबर',
      formSubmitted: 'अर्ज यशस्वीरित्या सबमिट केला!',
      submitting: 'तुमचा अर्ज सबमिट करत आहे...',
      errorSubmitting: 'अर्ज सबमिट करताना त्रुटी. कृपया पुन्हा प्रयत्न करा.',
      whyJoinTitle: 'चला धरुया, वाट प्रगतीची!',
      whyJoinDescription: 'तुम्हाला सक्षम करण्यासाठी शिवप्रताप मल्टीस्टेट ने नेहमीच तुमच्या सोबत राहण्याचा सेवाव्रत हाती घेतले आहे. आमच्या ग्राहकांपासून ते समाजातील प्रत्येक घटकापर्यंत आणि सर्वात महत्त्वाचे म्हणजे, आमच्या कर्मचाऱ्यांपर्यंत — प्रत्येकाला त्यांचे भविष्य घडवण्यासाठी सामर्थ्य देणार याचा आम्हाला दृढ विश्वास आहे.\n\nआम्ही केवळ एक आर्थिक संस्था नाही. आम्ही लोकांना त्यांची कौशल्ये आणि आवडीनिवडी मांडण्यासाठी एक व्यासपीठ देतो, जे स्पष्ट उद्दिष्टांवर आधारित आहे. तुम्ही नुकतेच करिअर सुरू करत असाल किंवा तुमच्या कौशल्यांना अनुभवाची जोड असेल, शिवप्रताप सोसायटीमध्ये तुम्हाला मनासारखे आणि प्रभावी काम करण्याची तसेच विकसित होण्याची भरपूर संधी मिळेल.',
      whatWeDoTitle: 'आमच्यासोबत का काम करावे?',
      features: [
        {
          title: 'सर्वसमावेशक कार्यसंस्कृती',
          description: 'कर्मचाऱ्यांसाठी आदर्श आणि सहकार्यपूर्ण कार्यस्थळ निर्माण करण्यासाठी आम्ही विविधता व समावेशकता प्रोत्साहित करतो.'
        },
        {
          title: 'प्रगतीची संधी',
          description: 'आमच्या कर्मचाऱ्यांना प्रशिक्षण, मार्गदर्शन आणि संस्थेअंतर्गत संधी देऊन प्रगती करण्यास आणि यशस्वी होण्यास मदत करतो.'
        },
        {
          title: 'उद्दिष्ट-केंद्रित कामकाज',
          description: 'जबाबदार आणि नैतिक बँकिंग उपायांद्वारे जगावर सकारात्मक प्रभाव पाडण्यावर आमचा विश्वास आहे.'
        },
        {
          title: 'प्रोत्साहन आणि फायदे',
          description: 'आम्ही आमच्या मेहनती कर्मचाऱ्यांना मदत आणि बक्षीस देण्यासाठी मेडिक्लेम आणि कामगिरीवर आधारित सुविधा देतो.'
        }
      ],
      workCultureTitle: 'आमच्या सोसायटी मधील कार्यप्रणाली / कामाची पद्धत',
      workCultureDescription: 'कामाच्या ठिकाणची सकारात्मकता हे केवळ कर्मचाऱ्यांसाठीच नाही, तर संस्थेच्या प्रगतीसाठीही महत्त्वाचे असते. आम्ही जाणीवपूर्वक असे वातावरण तयार करतो जिथे आमचे कर्मचारी मोकळेपणाने वावरु शकतात, विचार करु शकतात आणि त्यांना सर्वोत्तम काम करण्याची प्रेरणा मिळते.\n\nउत्कृष्ट काम करण्यासोबतच, आमची टीम सण-समारंभ, उत्सव आणि इतर विशेष कार्यक्रम एकत्र साजरे करते. ही आपुलकी, पाठिंबा आणि एकता प्रत्येक शिवप्रताप शाखेला काम करण्याची उमेद देते.'
    }
  };

  const currentContent = translations[language];

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;

    if (name === 'phone') {
      // Only allow numbers and max 10 digits
      const numericValue = value.replace(/[^0-9]/g, '');
      if (numericValue.length <= 10) {
        setFormData(prev => ({
          ...prev,
          [name]: numericValue
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'file' ? files[0] : value
      }));
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate phone number length
    if (formData.phone.length !== 10) {
      alert(currentContent.invalidPhone);
      return;
    }

    setIsSubmitting(true);

    try {
      let resumeURL = '';

      // Upload resume to Firebase Storage if a file is selected
      if (formData.resume) {
        const resumeFile = formData.resume;
        const timestamp = Date.now();
        const fileName = `resumes/${timestamp}_${resumeFile.name}`;
        const resumeStorageRef = storageRef(storage, fileName);

        // Upload file
        await uploadBytes(resumeStorageRef, resumeFile);

        // Get download URL
        resumeURL = await getDownloadURL(resumeStorageRef);
      }

      // Create application data object
      const applicationData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,

        gender: formData.gender,
        dateOfBirth: formData.dateOfBirth,
        address: formData.address,

        yearOfPassing: formData.yearOfPassing,
        resumeURL: resumeURL,
        submittedAt: new Date().toISOString(),
        status: 'pending'
      };

      // Save to Firebase Realtime Database
      const applicationsRef = ref(database, 'shivpratapmultistate/applications');
      const newApplicationRef = push(applicationsRef);
      await set(newApplicationRef, applicationData);

      // Show success message
      alert(currentContent.formSubmitted);

      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',

        gender: '',
        dateOfBirth: '',
        address: '',

        yearOfPassing: '',
        resume: null
      });

      // Reset file input
      const fileInput = document.getElementById('resume-upload');
      if (fileInput) {
        fileInput.value = '';
      }

    } catch (error) {
      console.error('Error submitting application:', error);
      alert(currentContent.errorSubmitting + ' ' + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };





  // Generate years for dropdown
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 30 }, (_, i) => currentYear - i);

  return (
    <div className="font-sans bg-gradient-to-b from-rose-50 to-white min-h-screen" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
      {/* Google Font Import */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700;800;900&display=swap');
        `}
      </style>

      {/* Hero Banner Section */}
      <section
        className="relative h-[400px] overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, #1e1e4a 0%, #2d2d6e 50%, #3a3a8a 100%)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0">
          {/* Pattern Overlay */}
          <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E")`,
            backgroundSize: '300px'
          }}></div>
        </div>

        <div className="relative h-full flex flex-col justify-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Breadcrumb */}
            <nav className="flex items-center text-blue-200 text-sm mb-6">
              <a href="/" className="flex items-center hover:text-white transition-colors">
                <FaHome className="mr-2" />
                {currentContent.breadcrumbHome}
              </a>
              <FaChevronRight className="mx-2 opacity-50" />
              <span className="font-semibold text-white">{currentContent.breadcrumbCareer}</span>
            </nav>


            {/* Hero Banner Text - Main Message */}
            <div className="max-w-2xl">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
                {language === 'mr' ? (
                  <>
                    <div className="mb-2">करियर घडवण्यासाठी,</div>
                    <div className="mb-2">भविष्य उज्ज्वल करण्यासाठी,</div>
                    <div>आम्ही तुमच्या सोबती!</div>
                  </>
                ) : (
                  <>
                    <div className="mb-2">Build your career,</div>
                    <div className="mb-2">Brighten your future,</div>
                    <div>We are with you!</div>
                  </>
                )}
              </h1>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Why Join Us Section */}
        <div className="mb-12">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
              {currentContent.whyJoinTitle}
            </h2>
            <p className="text-gray-600 max-w-4xl mx-auto text-base md:text-lg leading-relaxed" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
              {currentContent.whyJoinDescription}
            </p>
          </div>

          {/* What We Do Title */}
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
              {currentContent.whatWeDoTitle}
            </h3>
          </div>

          {/* Feature Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {currentContent.features.map((feature, index) => {
              const icons = [FaUsers, FaChartLine, FaLaptop, FaGift];
              const Icon = icons[index];
              const colors = [
                'from-blue-600 to-blue-800',
                'from-indigo-600 to-indigo-800',
                'from-purple-600 to-purple-800',
                'from-pink-600 to-pink-800'
              ];

              return (
                <div
                  key={index}
                  className="bg-gradient-to-br from-indigo-900 to-purple-900 rounded-2xl p-6 text-white shadow-xl hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300"
                  style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}
                >
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center">
                      <Icon className="text-4xl text-green-300" />
                    </div>
                  </div>
                  <h4 className="text-xl font-bold text-center mb-3">
                    {feature.title}
                  </h4>
                  <p className="text-white/90 text-sm text-center leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Work Culture Section */}
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-12">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
              {currentContent.workCultureTitle}
            </h3>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed" style={{ fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
              {currentContent.workCultureDescription}
            </p>
          </div>
        </div>

        {/* Application Form Section */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-2">
              {currentContent.applicationForm}
            </h2>
            <p className="text-gray-500 text-sm mt-1">{currentContent.fillApplication}</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Personal Information Section */}
            <div>
              <h3 className="text-xl font-bold text-gray-800 mb-6 pb-2 border-b border-gray-200 flex items-center">
                <FaUser className="mr-2 text-rose-600" />
                {currentContent.personalInfo}
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    <FaUser className="inline mr-2 text-gray-400" />
                    {currentContent.name} *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent"
                    placeholder={currentContent.name}
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    <FaEnvelope className="inline mr-2 text-gray-400" />
                    {currentContent.email} *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent"
                    placeholder={currentContent.email}
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    <FaPhone className="inline mr-2 text-gray-400" />
                    {currentContent.phoneNo} *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    maxLength={10}
                    pattern="[0-9]{10}"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent"
                    placeholder={currentContent.phoneNo}
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    <FaCalendar className="inline mr-2 text-gray-400" />
                    {currentContent.dateOfBirth} *
                  </label>
                  <input
                    type="date"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent"
                  />
                </div>



                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    <FaTransgender className="inline mr-2 text-gray-400" />
                    {currentContent.gender} *
                  </label>
                  <div className="flex space-x-4">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="male"
                        checked={formData.gender === 'male'}
                        onChange={handleInputChange}
                        required
                        className="mr-2"
                      />
                      {currentContent.male}
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="female"
                        checked={formData.gender === 'female'}
                        onChange={handleInputChange}
                        className="mr-2"
                      />
                      {currentContent.female}
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="others"
                        checked={formData.gender === 'others'}
                        onChange={handleInputChange}
                        className="mr-2"
                      />
                      {currentContent.others}
                    </label>
                  </div>
                </div>



                <div className="md:col-span-2">
                  <label className="block text-gray-700 font-medium mb-2">
                    {currentContent.address} *
                  </label>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    required
                    rows="3"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent"
                    placeholder={currentContent.address}
                  />
                </div>
              </div>
            </div>

            {/* Education & Experience Section */}
            <div>
              <h3 className="text-xl font-bold text-gray-800 mb-6 pb-2 border-b border-gray-200 flex items-center">
                <FaGraduationCap className="mr-2 text-rose-600" />
                {currentContent.educationInfo}
              </h3>
              <div className="grid grid-cols-1 gap-6">
                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    {currentContent.yearOfPassing} *
                  </label>
                  <select
                    name="yearOfPassing"
                    value={formData.yearOfPassing}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent"
                  >
                    <option value="">{currentContent.selectYearOfPassing}</option>
                    {years.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>



                <div className="md:col-span-2">
                  <label className="block text-gray-700 font-medium mb-2">
                    <FaFileUpload className="inline mr-2 text-gray-400" />
                    {currentContent.uploadResume}
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-rose-400 transition-colors">
                    <input
                      type="file"
                      name="resume"
                      onChange={handleInputChange}

                      accept=".pdf,.doc,.docx"
                      className="hidden"
                      id="resume-upload"
                    />
                    <label htmlFor="resume-upload" className="cursor-pointer">
                      <div className="text-gray-600 mb-2">
                        <FaFileUpload className="text-3xl mx-auto mb-2 text-gray-400" />
                        <p className="font-medium">{currentContent.uploadCvResume}</p>
                        <p className="text-sm text-gray-500 mt-1">(PDF, DOC, DOCX up to 5MB)</p>
                      </div>
                      <span className="inline-block px-4 py-2 bg-rose-600 text-white rounded-lg hover:bg-rose-700 transition-colors">
                        {formData.resume ? formData.resume.name : currentContent.chooseFile}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Section */}
            <div className="pt-6 border-t border-gray-200">
              <div className="flex justify-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`px-8 py-3 bg-gradient-to-r from-rose-600 to-rose-800 text-white rounded-lg font-bold text-lg hover:shadow-lg transition-all duration-300 flex items-center ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                >
                  {isSubmitting ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                      {currentContent.submitting}
                    </>
                  ) : (
                    <>
                      <FaPaperPlane className="mr-2" />
                      {currentContent.submit}
                    </>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Career;